import {
	mapActions
} from 'vuex';

import LogRocket from 'logrocket';

export default {
	name: 'schoolastic',
	computed: {
		isIframe() {
			return window.self !== window.top;
		}
	},
	methods: {
		...mapActions([
			'putLogged'
		]),
		sendIframeMessage(data) {

			return window.parent.postMessage({
				schoolastic: data
			}, '*');

		},
		onElementHeightChange(element, callback) { // https://stackoverflow.com/questions/14866775/detect-document-height-change#answer-14901150

			let lastHeight = element.clientHeight;
			let newHeight;

			(function run() {

				newHeight = element.clientHeight;

				if (lastHeight !== newHeight) {
					callback();
				}

				lastHeight = newHeight;

				if (element.onElementHeightChangeTimer) {
					clearTimeout(element.onElementHeightChangeTimer);
				}

				element.onElementHeightChangeTimer = setTimeout(run, 200);

			}());

		}
	},
	created() {

		/*! <iframe /> workaround *********************************************/

		const context = this;
		const body = document.body;
		const html = document.documentElement;
		const iframeHeight = Math.max(
			body.scrollHeight,
			body.offsetHeight,
			html.clientHeight,
			html.scrollHeight,
			html.offsetHeight
		);

		context.sendIframeMessage({
			giveMeUserData: true
		});

		context.sendIframeMessage({
			iframeHeight,
			locationHash: window.location.hash
		});

		context.onElementHeightChange(document.body, () => {

			context.sendIframeMessage({
				iframeHeight,
				locationHash: window.location.hash
			});

		});

		window.addEventListener('message', (event) => {

			if (event.data.schoolastic && event.data.schoolastic.user && event.data.schoolastic.school) {

				context.putLogged(event.data.schoolastic);

				const {
					user,
					school
				} = event.data.schoolastic;

				if (window.Rollbar) {

					Rollbar.configure({
						payload: {
							person: {
								id: user.id,
								username: user.name,
								email: user.email,
							},
							school: school
						}
					});

				}

				if (window.LogRocket) {

					LogRocket.identify(user.id, {
						name: user.name,
						email: user.email,
						School: school,
						Resolution: `${ screen.width }x${ screen.height }`
					});

				}

			}

		}, false);

		/*! End <iframe /> workaround *****************************************/

	}
};



// WEBPACK FOOTER //
// ./sources/index.js